import * as termsApi from '@/network/api/terms.api.js'
import * as accountsApi from '@/network/api/accounts.api.js'

/** requests Available Products
@return { promise } - Available Products request
*/
export const availableProductsFetch = async (context, payload) => {
    const res = await termsApi.getAvailableProducts(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_AVAILABLE_PRODUCTS', data)
    }
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearProductsListFeatureStates = async (context, payload) => {
    context.commit('CLEAR_PRODUCTS_LIST_FEATURE_STATE')
}

/** requests Accounts Balance
@return { promise } - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountsApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests Product Interest Rates
@return { promise } - Product Interest Rates request
*/
export const requestProductInterestRates = async (context, payload) => {
    context.commit('SAVE_PRODUCT_INTEREST_RATES', [])

    const res = await termsApi.getProductInterestRates(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PRODUCT_INTEREST_RATES', data.interestRates)
    }
    return res
}

/** requests Product Plafon
@return { promise } - Product Plafon request
*/
export const requestGetProductPlafond = async (context, payload) => {
    const res = await termsApi.getProductPlafond(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PRODUCT_PLAFOND', data)
    }
    return res
}

/** Simulates DP
@return { promise } - Simulates DP
*/
export const simulateDP = async (context, payload) => {
    const res = await termsApi.simulateDp(payload)
    return res
}

/** Subscribe DP Product
@return { promise } - Subscribe DP Product
*/
export const subscribeDPProduct = async (context, payload) => {
    const res = await termsApi.createDp(payload)
    return res
}

/** Clear createDP states
@return { promise } - Subscribe DP Product
*/
export const clearCreateDPStates = async (context, payload) => {
    context.commit('CLEAR_CREATE_DP_STATES')
}
